import { jsx } from "react/jsx-runtime";
import { Image } from "tamagui";
function ImageDemo() {
  return /* @__PURE__ */ jsx(
    Image,
    {
      source: {
        uri: "https://placekitten.com/200/300",
        width: 200,
        height: 300
      }
    }
  );
}
export {
  ImageDemo
};
//# sourceMappingURL=ImageDemo.js.map
